import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'crop-portrait', 'CropPortrait', [["path",{"d":"M6 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -12"}]]);